import IconHOC from '../IconHOC';

import { ReactComponent as ChevronLeftIcon } from './chevronLeft.svg';

export const ChevronLeft = IconHOC(ChevronLeftIcon);
